export default __webpack_public_path__ + "locales/el-GR/ArchiveDialog.json?hash=a12208d46cdc6b7f590405a12862dded";